import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';
import { buildLocationAPIPayload } from 'store/utils/userLocation.utils';
import { groupItemsByKey } from 'utils/data/parse.utils';

const normalizeTideResponse = (rawData) =>
  [
    ...groupItemsByKey(
      rawData,
      (item) => item.tide_name,
      (item) => ({ ...item }),
    ),
  ].map(([location, forecast]) => ({ location, forecast }));

export const marineApi = createApi({
  reducerPath: 'marineApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['MarineWeather'],
  endpoints: (builder) => ({
    getDetailedMarine7: builder.query({
      query: (location) => ({
        url: '/v2/custom-weather/forecast/marine/7-day',
        params: buildLocationAPIPayload(location),
      }),
      transformResponse: (response) => response?.result,
      providesTags: ['MarineWeather', { type: 'MarineWeather', id: 'DETAILED_7_DAY' }],
    }),
    getBuoyConditions: builder.query({
      query: (location) => ({
        url: '/v2/custom-weather/marine/buoy',
        params: {
          ...buildLocationAPIPayload(location),
          limit: 1000,
        },
      }),
      transformResponse: (response) => response?.result,
      providesTags: ['MarineWeather', { type: 'MarineWeather', id: 'BUOY' }],
    }),
    getTideTable: builder.query({
      query: (location) => ({
        url: '/v2/custom-weather/marine/tide',
        params: buildLocationAPIPayload(location),
      }),
      transformResponse: (response) => {
        const parsed =
          response?.result?.map((item) => ({
            ...item,
            tide: typeof item?.tide === 'string' ? JSON.parse(item.tide) : item.tide,
          })) ?? [];

        return normalizeTideResponse(parsed);
      },
      providesTags: ['MarineWeather', { type: 'MarineWeather', id: 'TIDE' }],
    }),
  }),
});

export const { useGetDetailedMarine7Query, useGetBuoyConditionsQuery, useGetTideTableQuery } =
  marineApi;
